import { render, staticRenderFns } from "./AppOrderingSystems.vue?vue&type=template&id=0555f53e&"
import script from "./AppOrderingSystems.vue?vue&type=script&lang=js&"
export * from "./AppOrderingSystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports